import { useState } from 'react';
import { Message, AgentWithIcon, PendingActionType } from '../../../types/chat';
import { Chat as ChatType, TokenUsageInfo } from '../../../types';

/**
 * チャットページの状態管理を行うカスタムフック
 */
export const useChatState = () => {
  // UI状態
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [agentSelectorVisible, setAgentSelectorVisible] = useState(false);
  const [messageInput, setMessageInput] = useState('');
  const [isNewChat, setIsNewChat] = useState<boolean>(false);
  
  // メッセージ関連
  const [messages, setMessages] = useState<Message[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [typingIndicator, setTypingIndicator] = useState(false);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const [isRegenerating, setIsRegenerating] = useState(false);
  const [regeneratingMessageId, setRegeneratingMessageId] = useState<number | null>(null);
  
  // データ関連
  const [chats, setChats] = useState<ChatType[]>([]);
  const [agents, setAgents] = useState<AgentWithIcon[]>([]);
  const [isLoadingAgents, setIsLoadingAgents] = useState<boolean>(true);
  const [selectedAgent, setSelectedAgent] = useState<AgentWithIcon | null>(null);
  
  // トークン使用関連
  const [orgTokenInfo, setOrgTokenInfo] = useState<TokenUsageInfo | null>(null);
  const [isLoadingOrgInfo, setIsLoadingOrgInfo] = useState<boolean>(false);
  
  // URL関連
  const [agentIdFromURL, setAgentIdFromURL] = useState<number | null>(null);
  // 現在のチャットID（ルートに反映される前の一時ID保持にも利用）
  const [currentChatId, setCurrentChatId] = useState<number | null>(null);
  
  // ThinkingProcess関連
  const [showThinkingProcess, setShowThinkingProcess] = useState<boolean>(false);
  const [thinkingMessage, setThinkingMessage] = useState<string>('');

  // GPT-5 AIのthinking（reasoning summary）内容
  const [aiThinkingContent, setAiThinkingContent] = useState<string>('');

  // メッセージ追加用の関数
  const addMessage = (message: Message) => {
    setMessages(prev => [...prev, message]);
  };

  return {
    // UI状態
    sidebarCollapsed, setSidebarCollapsed,
    agentSelectorVisible, setAgentSelectorVisible,
    messageInput, setMessageInput,
    isNewChat, setIsNewChat,

    // メッセージ関連
    messages, setMessages, addMessage,
    isLoading, setIsLoading,
    typingIndicator, setTypingIndicator,
    suggestions, setSuggestions,
    isRegenerating, setIsRegenerating,
    regeneratingMessageId, setRegeneratingMessageId,

    // データ関連
    chats, setChats,
    agents, setAgents,
    isLoadingAgents, setIsLoadingAgents,
    selectedAgent, setSelectedAgent,

    // トークン使用関連
    orgTokenInfo, setOrgTokenInfo,
    isLoadingOrgInfo, setIsLoadingOrgInfo,

    // URL関連
    agentIdFromURL, setAgentIdFromURL,
    currentChatId, setCurrentChatId,

    // ThinkingProcess関連
    showThinkingProcess, setShowThinkingProcess,
    thinkingMessage, setThinkingMessage,

    // GPT-5 AIのthinking（reasoning summary）内容
    aiThinkingContent, setAiThinkingContent
  };
};
